import React, { useState, useEffect, createContext, useContext } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import PropTypes from 'prop-types'
import { useIMSForm } from '../detail/IMSForm/IMSFormContext'
import { fetchJsonWithAuth } from '../../../Utils/ServerUtil'
import { FormHelperText } from '@material-ui/core'
import { InputAdornment } from '@material-ui/core'
import SearchIcon from '@mui/icons-material/Search'

const upcomingAuctions = [
    {
        auction_id: 11402,
        auction: '251029',
        title: 'SOLD! October 29 Ag Equipment Auction',
        auction_date: '251029',
        workspace_label: '251029ag',
    },
    {
        auction_id: 11403,
        auction: '251030',
        title: 'Thursday October 30 Truck and Trailer Auction',
        auction_date: '251030',
        workspace_label: '251030truck',
    },
    {
        auction_id: 11404,
        auction: '251104',
        title: 'Tuesday November 04 Government Auction',
        auction_date: '251104',
        workspace_label: '251104govt',
    },
    {
        auction_id: 11405,
        auction: '251105',
        title: 'Wednesday November 05 Vehicles and Equipment Auction',
        auction_date: '251105',
        workspace_label: '251105ve',
    },
    {
        auction_id: 11406,
        auction: '251106',
        title: 'Thursday November 06 Construction Equipment Auction',
        auction_date: '251106',
        workspace_label: '251106const',
    },
    {
        auction_id: 11407,
        auction: '251112',
        title: 'Wednesday November 12 Ag Equipment Auction',
        auction_date: '251112',
        workspace_label: '251112ag',
    },
    {
        auction_id: 11408,
        auction: '251113',
        title: 'Thursday November 13 Truck and Trailer Auction',
        auction_date: '251113',
        workspace_label: '251113truck',
    },
    {
        auction_id: 11409,
        auction: '251118',
        title: 'Tuesday November 18 Government Auction',
        auction_date: '251118',
        workspace_label: '251118govt',
    },
    {
        auction_id: 11410,
        auction: '251119',
        title: 'Wednesday November 19 Vehicles and Equipment Auction',
        auction_date: '251119',
        workspace_label: '251119ve',
    },
    {
        auction_id: 11411,
        auction: '251120',
        title: 'Thursday November 20 Construction Equipment Auction',
        auction_date: '251120',
        workspace_label: '251120const',
    },
    {
        auction_id: 11423,
        auction: '251202',
        title: 'Tuesday December 02 Government Auction',
        auction_date: '251202',
        workspace_label: '251202govt',
    },
    {
        auction_id: 11424,
        auction: '251203',
        title: 'Wednesday December 03 Vehicles and Equipment Auction',
        auction_date: '251203',
        workspace_label: '251203ve',
    },
    {
        auction_id: 11425,
        auction: '251204',
        title: 'Thursday December 04 Construction Equipment Auction',
        auction_date: '251204',
        workspace_label: '251204const',
    },
    {
        auction_id: 11426,
        auction: '251210',
        title: 'Wednesday December 10 Ag Equipment Auction',
        auction_date: '251210',
        workspace_label: '251210ag',
    },
    {
        auction_id: 11427,
        auction: '251211',
        title: 'Thursday December 11 Truck and Trailer Auction',
        auction_date: '251211',
        workspace_label: '251211truck',
    },
    {
        auction_id: 11430,
        auction: '251216',
        title: 'Tuesday December 16 Government Auction',
        auction_date: '251216',
        workspace_label: '251216govt',
    },
    {
        auction_id: 11431,
        auction: '251217',
        title: 'Wednesday December 17 Vehicles and Equipment Auction',
        auction_date: '251217',
        workspace_label: '251217ve',
    },
    {
        auction_id: 11432,
        auction: '251218',
        title: 'Thursday December 18 Construction Equipment Auction',
        auction_date: '251218',
        workspace_label: '251218const',
    },
    {
        auction_id: 11433,
        auction: '251230',
        title: 'Tuesday December 30 Vehicles and Equipment Auction',
        auction_date: '251230',
        workspace_label: '251230ve',
    },
    {
        auction_id: 11434,
        auction: '251230A',
        title: 'Tuesday December 30 Ag Equipment Auction',
        auction_date: '251230',
        workspace_label: '251230ag',
    },
    {
        auction_id: 11435,
        auction: '251231',
        title: 'Wednesday December 31 Construction Equipment Auction',
        auction_date: '251231',
        workspace_label: '251231const',
    },
    {
        auction_id: 11436,
        auction: '251231A',
        title: 'Wednesday December 31 Truck and Trailer Auction',
        auction_date: '251231',
        workspace_label: '251231truck',
    },
]

// Step 1: Create a context
export const IMSContext = createContext()

IMSFormCategorySelect.propTypes = {
    customerNumber: PropTypes.string,
}

function IMSFormCategorySelect({ evalItem }) {
    // Step 2: Use state from the context
    const {
        categoriesData,
        setCategoriesData,
        industriesData,
        setIndustriesData,
        selectedIndustry,
        setSelectedIndustry,
        selectedFamily,
        setSelectedFamily,
        selectedCategory,
        setSelectedCategory,
        setSelectedOpportunity,
        estimatedHammer,
        setEstimatedHammer,
        jobCodeData,
        setJobCodeData,
        auctionsJobCodeData,
        setAuctionsJobCodeData,
        setNominationValue,
    } = useContext(IMSContext)

    const { imsForm, setImsForm } = useIMSForm()
    const [isLoading, setIsLoading] = useState(true)
    const [dataSource, setDataSource] = useState('none') // 'none', 'mock', or 'api'
    const [lastValidJobCode, setLastValidJobCode] = useState(null)
    const [isInitialized, setIsInitialized] = useState(false)
    const [initializedFromIMS, setInitializedFromIMS] = useState(false)

    // useEffect(() => {
    //   console.log("Filllaaaaaaaaaaaaaaaaaa==============================>,",{selectedCategory: selectedCategory, imsForm: imsForm, selectedIndustry: selectedIndustry, selectedFamily: selectedFamily});
    // }, [selectedCategory, imsForm, selectedIndustry, selectedFamily]);

    const imsFormData = async () => {
        try {
            const data = await fetchJsonWithAuth(
                'https://ims-api.purplewave.com/v1/industries?published=1'
            )
            setIndustriesData(data)

            const allCategories = data.flatMap((industry) =>
                industry.Families.flatMap((family) =>
                    family.Categories.map((category) => category.category)
                )
            )
            setCategoriesData(allCategories)
        } catch (error) {
            console.error('Error fetching industries:', error)
        }
    }

    // useEffect(() => {
    //   imsFormData();
    //   auctionsData();
    // }, []);

    // Separate useEffect for initial data loading
    useEffect(() => {
        const loadInitialData = async () => {
            setIsLoading(true)
            await Promise.all([imsFormData(), auctionsData()])
            setIsLoading(false)
        }

        loadInitialData()
    }, [])

    // Separate useEffect for handling job code initialization
    useEffect(() => {
        if (!isInitialized || !imsForm?.item?.ims_forms_data?.jobcode) return

        const jobcodeValue = imsForm.item.ims_forms_data.jobcode
        console.log(
            'Checking job code:',
            jobcodeValue,
            'with data source:',
            dataSource
        )

        // Keep the current job code if it was previously validated
        if (jobcodeValue === lastValidJobCode) {
            console.log('Using previously validated job code:', jobcodeValue)
            return
        }

        // Check current data source
        const currentData =
            auctionsJobCodeData.length > 0
                ? auctionsJobCodeData
                : upcomingAuctions
        const isValidJobCode = currentData.some(
            (auction) => auction.workspace_label === jobcodeValue
        )

        if (isValidJobCode) {
            console.log(
                'Valid job code found in',
                dataSource,
                'data:',
                jobcodeValue
            )
            setJobCodeData(jobcodeValue)
            setLastValidJobCode(jobcodeValue)
        } else if (dataSource === 'api') {
            // If not found in API data, check mock data
            const isValidMockJobCode = upcomingAuctions.some(
                (auction) => auction.workspace_label === jobcodeValue
            )

            if (isValidMockJobCode) {
                console.log('Valid job code found in mock data:', jobcodeValue)
                setJobCodeData(jobcodeValue)
                setLastValidJobCode(jobcodeValue)
                // Keep using mock data since we found a valid job code there
                setAuctionsJobCodeData(upcomingAuctions)
                setDataSource('mock')
            }
        }
    }, [isInitialized, imsForm, dataSource, auctionsJobCodeData])

    // Separate useEffect for estimated hammer
    useEffect(() => {
        if (imsForm?.item?.ims_forms_data?.capture_estimate) {
            console.log(
                'Setting Hammer:',
                imsForm.item.ims_forms_data.capture_estimate
            )
            setEstimatedHammer(imsForm.item.ims_forms_data.capture_estimate)
        }
    }, [imsForm])

    useEffect(() => {
        // Check if evalItem.item.ims_form_data.opportunity_id exists
        const opportunityId = imsForm?.item?.ims_forms_data?.opportunity_id
            ? imsForm?.item?.ims_forms_data?.opportunity_id
            : evalItem?.item?.ims_forms_data?.opportunity_id
        // If opportunityId exists, set the form to opportunityId, else set it to null
        setSelectedOpportunity(opportunityId ? opportunityId : null)
    }, [evalItem, imsForm])

    const industryOptions = industriesData.map((industry) => ({
        value: industry.industry,
        label: industry.industry,
    }))

    const familyOptions = selectedIndustry
        ? selectedIndustry.Families.map((family) => ({
              value: family.family,
              label: family.family,
          }))
        : []

    const categoryOptions = selectedFamily
        ? selectedFamily.Categories.map((category) => ({
              value: category.category,
              label: category.category,
          }))
        : []

    const handleIndustryChange = (event) => {
        const value = event.target.value
        const ind = industriesData.find((i) => i.industry === value) || null
        setSelectedIndustry(ind)
        setSelectedFamily(null)
        setSelectedCategory(null)
    }

    const handleFamilyChange = (event) => {
        const value = event.target.value
        const fam =
            selectedIndustry?.Families.find((f) => f.family === value) || null
        setSelectedFamily(fam)
        setSelectedCategory(null)
    }

    const handleCategoryChange = (event) => {
        const value = event.target.value
        const cat =
            selectedFamily?.Categories.find((c) => c.category === value) || null
        setSelectedCategory(cat)
    }

    const handleAutocompleteChange = (_, newValue) => {
        // If the input is cleared, reset selections
        if (!newValue) {
            setSelectedIndustry(null)
            setSelectedFamily(null)
            setSelectedCategory(null)
            return
        }

        // Do not run until industries are loaded
        if (!industriesData || industriesData.length === 0) return

        const selectedCategory = categoriesData.find(
            (category) => category === newValue
        )

        if (selectedCategory) {
            // Find the corresponding industry, family, and category
            for (const industry of industriesData) {
                for (const family of industry.Families) {
                    for (const category of family.Categories) {
                        if (category.category === newValue) {
                            console.log(
                                'Select Category in search:',
                                selectedCategory
                            )
                            setSelectedIndustry(industry)
                            setSelectedFamily(family)
                            setSelectedCategory(category)
                            return
                        }
                    }
                }
            }
        }

        // If no matching industry, family, and category found, do not reset unless input is cleared
    }

    useEffect(() => {
        if (!categoriesData || categoriesData.length === 0) return

        const selectedCategoryFromIMSform =
            imsForm?.item?.ims_forms_data?.category

        if (
            !initializedFromIMS &&
            selectedCategoryFromIMSform &&
            !selectedIndustry &&
            !selectedFamily &&
            !selectedCategory
        ) {
            handleAutocompleteChange(null, selectedCategoryFromIMSform)
            setInitializedFromIMS(true)
        }
    }, [
        imsForm,
        categoriesData,
        selectedIndustry,
        selectedFamily,
        selectedCategory,
        initializedFromIMS,
    ])

    const auctionsData = async () => {
        try {
            const data = await fetchJsonWithAuth(
                'https://dashboard.purplewave.com/v3/leads/upcomingauctions',
                { method: 'GET' }
            )
            if (data?.upcomingAuctions?.length > 0) {
                console.log('Setting API data')
                setAuctionsJobCodeData(data.upcomingAuctions)
                setDataSource('api')
            } else {
                console.log('API returned empty data, using mock data')
                setAuctionsJobCodeData(upcomingAuctions)
                setDataSource('mock')
            }
        } catch (error) {
            console.error('Error fetching auctions:', error)
            console.log('Error occurred, using mock data')
            setAuctionsJobCodeData(upcomingAuctions)
            setDataSource('mock')
        } finally {
            setIsInitialized(true)
        }
    }

    // Cleanup effect to reset context state when component unmounts
    useEffect(() => {
        return () => {
            setSelectedIndustry(null)
            setSelectedFamily(null)
            setSelectedCategory(null)
            setSelectedOpportunity('')
            setJobCodeData('')
            setEstimatedHammer('')
            setAuctionsJobCodeData([])
            setNominationValue('0')
        }
    }, [])

    return (
        <div>
            <div style={{ margin: '20px 0' }}></div>
            <Autocomplete
                disablePortal
                id="category-search"
                options={categoriesData}
                value={selectedCategory ? selectedCategory.category : null}
                sx={{ width: '60%' }}
                onChange={(_, newValue) =>
                    handleAutocompleteChange(_, newValue)
                }
                onInputChange={(event, value, reason) => {
                    if (value === '' || reason === 'clear') {
                        setSelectedIndustry(null)
                        setSelectedFamily(null)
                        setSelectedCategory(null)
                    }
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search Category"
                        variant="standard"
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                )}
            />
            <div style={{ margin: '30px 0', marginTop: '30px' }}></div>

            <FormControl fullWidth>
                <InputLabel
                    shrink={!!selectedIndustry}
                    htmlFor="industry-select"
                    style={{
                        backgroundColor: '#ffffff', // Match the background color of the form
                        padding: '0 4px', // Optional: adds padding to avoid label overlap with border
                        zIndex: 1, // Ensure label is on top of the border
                    }}
                >
                    Select Industry
                </InputLabel>
                <Select
                    value={selectedIndustry ? selectedIndustry.industry : ''}
                    onChange={handleIndustryChange}
                    label="Select Industry"
                    inputProps={{
                        name: 'industry',
                        id: 'industry-select',
                    }}
                    style={{
                        width: '60%',
                        fontWeight: 'normal',
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                zIndex: 2, // Ensure dropdown options appear above everything
                            },
                        },
                    }}
                >
                    {industryOptions.map((option, idx) => (
                        <MenuItem key={`industry-${idx}`} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <div style={{ margin: '12px 0' }}></div>

            <FormControl fullWidth>
                <InputLabel
                    shrink={!!selectedFamily}
                    htmlFor="family-select"
                    style={{
                        backgroundColor: '#ffffff', // Match the background color of the form
                        padding: '0 4px', // Adds padding to avoid label overlap with border
                        zIndex: 1, // Ensure label is on top of the border
                    }}
                >
                    Select Equipment Type
                </InputLabel>
                <Select
                    value={selectedFamily ? selectedFamily.family : ''}
                    onChange={handleFamilyChange}
                    label="Select Equipment Type"
                    inputProps={{
                        name: 'family',
                        id: 'family-select',
                    }}
                    style={{
                        width: '60%',
                        fontWeight: 'normal',
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                zIndex: 2, // Ensure dropdown options appear above everything
                            },
                        },
                    }}
                >
                    {familyOptions.map((option, idx) => (
                        <MenuItem key={`family-${idx}`} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <div style={{ margin: '12px 0' }}></div>

            <FormControl fullWidth>
                <InputLabel
                    shrink={!!selectedCategory}
                    htmlFor="category-select"
                    style={{
                        backgroundColor: '#ffffff',
                        padding: '0 4px',
                        zIndex: 1,
                        fontWeight: '400 !important',
                    }}
                >
                    Select Category
                </InputLabel>
                <Select
                    value={selectedCategory ? selectedCategory.category : ''}
                    onChange={handleCategoryChange}
                    label="Select Category"
                    inputProps={{
                        name: 'category',
                        id: 'category-select',
                    }}
                    style={{
                        width: '60%',
                        fontWeight: '400 !important',
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                zIndex: 2, // Ensure dropdown options appear above everything
                            },
                        },
                    }}
                >
                    {categoryOptions.map((option, idx) => (
                        <MenuItem key={`category-${idx}`} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <div style={{ margin: '12px 0' }}></div>
            <FormControl fullWidth>
                <InputLabel
                    id="jobcode-select-label"
                    shrink={!isInitialized || !!jobCodeData}
                    htmlFor="jobcode-select"
                    style={{
                        backgroundColor: '#ffffff',
                        padding: '0 4px',
                        zIndex: 1,
                    }}
                >
                    {!isInitialized
                        ? 'Loading Job Codes...'
                        : 'Select Job Code'}
                </InputLabel>
                <Select
                    labelId="jobcode-select-label"
                    value={jobCodeData || ''}
                    onChange={(event) => {
                        const newValue = event.target.value
                        console.log('Selected new job code:', newValue)
                        setJobCodeData(newValue)
                        setLastValidJobCode(newValue)
                    }}
                    label="Select Job Code"
                    inputProps={{
                        name: 'jobcode',
                        id: 'jobcode-select',
                    }}
                    style={{ width: '60%', fontWeight: 'normal' }}
                    disabled={!isInitialized}
                    renderValue={(selected) => selected || ''}
                >
                    {(() => {
                        const source =
                            auctionsJobCodeData.length > 0
                                ? auctionsJobCodeData
                                : upcomingAuctions
                        const hasCurrent =
                            jobCodeData &&
                            !source.some(
                                (j) => j.workspace_label === jobCodeData
                            )
                        const items = []
                        if (hasCurrent) {
                            items.push(
                                <MenuItem
                                    key={'current-jobcode'}
                                    value={jobCodeData}
                                >
                                    {jobCodeData}
                                </MenuItem>
                            )
                        }
                        return items.concat(
                            source.map((jobcode) => (
                                <MenuItem
                                    key={jobcode.auction_id}
                                    value={jobcode.workspace_label}
                                >
                                    {jobcode.workspace_label}
                                </MenuItem>
                            ))
                        )
                    })()}
                </Select>
                {!jobCodeData && isInitialized && (
                    <FormHelperText style={{ color: 'red' }}>
                        Form submission will fail if job code is not provided
                    </FormHelperText>
                )}
            </FormControl>

            <div style={{ margin: '12px 0' }}></div>

            <FormControl fullWidth>
                <TextField
                    label="Estimated Hammer"
                    value={estimatedHammer}
                    onChange={(event) => {
                        const value = event.target.value.replace(/[^0-9]/g, '')
                        setEstimatedHammer(value)
                    }}
                    InputProps={{
                        name: 'estimatedHammer',
                        id: 'estimatedHammer-select',
                        startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                        ),
                    }}
                    style={{ width: '60%', fontWeight: 'normal' }}
                    variant="outlined"
                />
            </FormControl>
        </div>
    )
}

export const IMSProvider = ({ children }) => {
    const [categoriesData, setCategoriesData] = useState([])
    const [industriesData, setIndustriesData] = useState([])
    const [selectedIndustry, setSelectedIndustry] = useState(null)
    const [selectedFamily, setSelectedFamily] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedOpportunity, setSelectedOpportunity] = useState('')
    const [jobCodeData, setJobCodeData] = useState('')
    const [estimatedHammer, setEstimatedHammer] = useState('')
    const [auctionsJobCodeData, setAuctionsJobCodeData] = useState([])
    const [nominationValue, setNominationValue] = useState('0')

    return (
        <IMSContext.Provider
            value={{
                categoriesData,
                setCategoriesData,
                industriesData,
                setIndustriesData,
                selectedIndustry,
                setSelectedIndustry,
                selectedFamily,
                setSelectedFamily,
                selectedCategory,
                setSelectedCategory,
                selectedOpportunity,
                setSelectedOpportunity,
                jobCodeData,
                setJobCodeData,
                auctionsJobCodeData,
                setAuctionsJobCodeData,
                estimatedHammer,
                setEstimatedHammer,
                nominationValue,
                setNominationValue,
            }}
        >
            {children}
        </IMSContext.Provider>
    )
}

export default IMSFormCategorySelect
